import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ScaffoldInspectionQuery, SiteDashBoardScaffoldInspectionData, SiteEndpointService } from 'app/core/hub-api';

import { QueryService } from '../../core/services/query.service';

// Queries data from the server (or in memory cache where specified) and allows consumer to subscribe to data changes.
@Injectable()
export class ScaffoldInspectionQueryService extends QueryService<SiteDashBoardScaffoldInspectionData[]> {

  constructor(private siteEndpointService: SiteEndpointService) { super(); }

  scaffoldInspectionQuery(useCached: boolean, siteId?: string): Observable<SiteDashBoardScaffoldInspectionData[]> {
    return super.query(useCached, siteId);
  }

  scaffoldInspectionDataChanges(siteId?: string): Observable<SiteDashBoardScaffoldInspectionData[]> {
    return super.cachedDataChanges(siteId);
  }

  protected getDataFromServer(siteId?: string): Observable<SiteDashBoardScaffoldInspectionData[]> {
    const query = Object.assign(new ScaffoldInspectionQuery(), { SiteId: siteId });
    return this.siteEndpointService.ScaffoldInspectionQuery(query);
  }
}
